
import axios from 'axios'

export const getMerchantRedeemable = async(organizationId, programId, merchantId) => {
    if (String(merchantId).startsWith('gcm-')) {
        const gcmId = String(merchantId).replace(/^gcm-/, '');
        const response = await axios.get(`/gcm/business/${gcmId}/redeemable`);
        return response.data;
    }
    const response = await axios.get(`/organization/${organizationId}/program/${programId}/merchant/${merchantId}/redeemable`)
    return response.data
}